import React, { useState, useEffect } from 'react';
import { CheckCircle, Search, FileCheck, Eye, Award, Shield, Clock, DollarSign, Star, Phone, Mail, MapPin, Send, Sparkles, FileText, Copyright } from 'lucide-react';
import SEO from '../components/SEO';
import ProcessSection from '../components/ProcessSection';
import PricingSection from '../components/PricingSection';
import { getCountryInfo, handleFormSubmission } from '../services/api';

const TrademarkPPCLanding = () => {
  const [heroFormData, setHeroFormData] = useState({
    name: '',
    countryCode: '+1',
    phone: '',
    email: '',
    message: ''
  });

  const [bottomFormData, setBottomFormData] = useState({
    name: '',
    countryCode: '+1',
    phone: '',
    email: '',
    message: ''
  });
  
  const [heroErrors, setHeroErrors] = useState({});
  const [bottomErrors, setBottomErrors] = useState({});
  const [heroSubmitted, setHeroSubmitted] = useState(false);
  const [bottomSubmitted, setBottomSubmitted] = useState(false);
  const [heroApiError, setHeroApiError] = useState('');
  const [bottomApiError, setBottomApiError] = useState('');
  const [heroSubmitting, setHeroSubmitting] = useState(false);
  const [bottomSubmitting, setBottomSubmitting] = useState(false);

  const countryCodes = [
    { code: '+1', country: 'US', flag: '🇺🇸', length: 10, name: 'United States' },
    { code: '+1', country: 'CA', flag: '🇨🇦', length: 10, name: 'Canada' },
    { code: '+44', country: 'GB', flag: '🇬🇧', length: 10, name: 'United Kingdom' },
    { code: '+91', country: 'IN', flag: '🇮🇳', length: 10, name: 'India' },
    { code: '+61', country: 'AU', flag: '🇦🇺', length: 9, name: 'Australia' },
    { code: '+92', country: 'PK', flag: '🇵🇰', length: 10, name: 'Pakistan' },
    { code: '+86', country: 'CN', flag: '🇨🇳', length: 11, name: 'China' },
    { code: '+81', country: 'JP', flag: '🇯🇵', length: 10, name: 'Japan' },
    { code: '+49', country: 'DE', flag: '🇩🇪', length: 10, name: 'Germany' },
    { code: '+33', country: 'FR', flag: '🇫🇷', length: 9, name: 'France' },
    { code: '+39', country: 'IT', flag: '🇮🇹', length: 10, name: 'Italy' },
    { code: '+34', country: 'ES', flag: '🇪🇸', length: 9, name: 'Spain' },
    { code: '+52', country: 'MX', flag: '🇲🇽', length: 10, name: 'Mexico' },
    { code: '+55', country: 'BR', flag: '🇧🇷', length: 11, name: 'Brazil' },
    { code: '+27', country: 'ZA', flag: '🇿🇦', length: 9, name: 'South Africa' },
    { code: '+971', country: 'AE', flag: '🇦🇪', length: 9, name: 'UAE' },
    { code: '+31', country: 'NL', flag: '🇳🇱', length: 9, name: 'Netherlands' },
    { code: '+966', country: 'SA', flag: '🇸🇦', length: 9, name: 'Saudi Arabia' },
    { code: '+20', country: 'EG', flag: '🇪🇬', length: 10, name: 'Egypt' },
    { code: '+234', country: 'NG', flag: '🇳🇬', length: 10, name: 'Nigeria' },
    { code: '+254', country: 'KE', flag: '🇰🇪', length: 10, name: 'Kenya' },
    { code: '+7', country: 'RU', flag: '🇷🇺', length: 10, name: 'Russia' },
    { code: '+90', country: 'TR', flag: '🇹🇷', length: 10, name: 'Turkey' },
    { code: '+82', country: 'KR', flag: '🇰🇷', length: 10, name: 'South Korea' },
    { code: '+66', country: 'TH', flag: '🇹🇭', length: 9, name: 'Thailand' },
    { code: '+60', country: 'MY', flag: '🇲🇾', length: 9, name: 'Malaysia' },
    { code: '+65', country: 'SG', flag: '🇸🇬', length: 8, name: 'Singapore' },
    { code: '+63', country: 'PH', flag: '🇵🇭', length: 10, name: 'Philippines' },
    { code: '+62', country: 'ID', flag: '🇮🇩', length: 10, name: 'Indonesia' },
    { code: '+84', country: 'VN', flag: '🇻🇳', length: 9, name: 'Vietnam' },
    { code: '+880', country: 'BD', flag: '🇧🇩', length: 10, name: 'Bangladesh' },
    { code: '+32', country: 'BE', flag: '🇧🇪', length: 9, name: 'Belgium' },
    { code: '+46', country: 'SE', flag: '🇸🇪', length: 9, name: 'Sweden' },
    { code: '+47', country: 'NO', flag: '🇳🇴', length: 8, name: 'Norway' },
    { code: '+45', country: 'DK', flag: '🇩🇰', length: 8, name: 'Denmark' },
    { code: '+358', country: 'FI', flag: '🇫🇮', length: 9, name: 'Finland' },
    { code: '+48', country: 'PL', flag: '🇵🇱', length: 9, name: 'Poland' },
    { code: '+30', country: 'GR', flag: '🇬🇷', length: 10, name: 'Greece' },
    { code: '+351', country: 'PT', flag: '🇵🇹', length: 9, name: 'Portugal' },
    { code: '+420', country: 'CZ', flag: '🇨🇿', length: 9, name: 'Czech Republic' },
    { code: '+43', country: 'AT', flag: '🇦🇹', length: 10, name: 'Austria' },
    { code: '+41', country: 'CH', flag: '🇨🇭', length: 9, name: 'Switzerland' },
    { code: '+353', country: 'IE', flag: '🇮🇪', length: 9, name: 'Ireland' },
    { code: '+64', country: 'NZ', flag: '🇳🇿', length: 9, name: 'New Zealand' },
    { code: '+54', country: 'AR', flag: '🇦🇷', length: 10, name: 'Argentina' },
    { code: '+56', country: 'CL', flag: '🇨🇱', length: 9, name: 'Chile' },
    { code: '+57', country: 'CO', flag: '🇨🇴', length: 10, name: 'Colombia' },
    { code: '+51', country: 'PE', flag: '🇵🇪', length: 9, name: 'Peru' },
    { code: '+58', country: 'VE', flag: '🇻🇪', length: 10, name: 'Venezuela' },
    { code: '+972', country: 'IL', flag: '🇮🇱', length: 9, name: 'Israel' }
  ];

  // Fetch country info and auto-select dial code on component mount
  useEffect(() => {
    const loadCountryInfo = async () => {
      try {
        const countryInfo = await getCountryInfo();
        if (countryInfo && countryInfo.dialCode) {
          // Auto-select dial code in both forms
          setHeroFormData(prev => ({ ...prev, countryCode: countryInfo.dialCode }));
          setBottomFormData(prev => ({ ...prev, countryCode: countryInfo.dialCode }));
        }
      } catch (error) {
        console.error('Error loading country info:', error);
        // Silently fail - forms will use default +1
      }
    };
    
    loadCountryInfo();
  }, []);

  // Conversion tracking placeholder
  useEffect(() => {
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: 'Trademark Registration PPC Landing',
        page_location: window.location.href,
        page_path: '/lp/'
      });
    }
    if (window.fbq) {
      window.fbq('track', 'PageView');
    }
  }, []);

  const validatePhone = (phone, countryCode) => {
    const cleanPhone = phone.replace(/\D/g, '');
    // Phone must have at least 7 digits
    if (cleanPhone.length < 7) return false;
    
    const selectedCountry = countryCodes.find(c => c.code === countryCode);
    if (!selectedCountry) {
      // If country not in list, accept 7-15 digit numbers
      return cleanPhone.length >= 7 && cleanPhone.length <= 15;
    }
    // Check exact length for known countries
    return cleanPhone.length === selectedCountry.length;
  };

  const validateEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  const handleHeroChange = (e) => {
    const { name, value } = e.target;
    setHeroFormData(prev => ({ ...prev, [name]: value }));
    if (heroErrors[name]) {
      setHeroErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleBottomChange = (e) => {
    const { name, value } = e.target;
    setBottomFormData(prev => ({ ...prev, [name]: value }));
    if (bottomErrors[name]) {
      setBottomErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = (formData) => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!validatePhone(formData.phone, formData.countryCode)) {
      const selectedCountry = countryCodes.find(c => c.code === formData.countryCode);
      if (selectedCountry) {
        newErrors.phone = `Phone must be ${selectedCountry.length} digits`;
      } else {
        newErrors.phone = 'Invalid phone number';
      }
    }
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Invalid email';
    }
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    return newErrors;
  };

  const handleHeroSubmit = async (e) => {
    e.preventDefault();
    
    // Clear previous API errors
    setHeroApiError('');
    
    const newErrors = validateForm(heroFormData);
    if (Object.keys(newErrors).length > 0) {
      setHeroErrors(newErrors);
      return;
    }

    setHeroSubmitting(true);

    // Conversion tracking
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-CONVERSION_ID/LABEL' });
    }
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }

    // Submit to API
    await handleFormSubmission(
      heroFormData,
      (result) => {
        // Success callback
        console.log('Hero form submitted successfully:', result);
        setHeroSubmitted(true);
        setHeroSubmitting(false);
        // Redirect happens automatically in handleFormSubmission
      },
      (error) => {
        // Error callback
        console.error('Hero form submission error:', error);
        setHeroApiError(error);
        setHeroSubmitting(false);
      }
    );
  };

  const handleBottomSubmit = async (e) => {
    e.preventDefault();
    
    // Clear previous API errors
    setBottomApiError('');
    
    const newErrors = validateForm(bottomFormData);
    if (Object.keys(newErrors).length > 0) {
      setBottomErrors(newErrors);
      return;
    }

    setBottomSubmitting(true);

    // Conversion tracking
    if (window.gtag) {
      window.gtag('event', 'conversion', { send_to: 'AW-CONVERSION_ID/LABEL' });
    }
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }

    // Submit to API
    await handleFormSubmission(
      bottomFormData,
      (result) => {
        // Success callback
        console.log('Bottom form submitted successfully:', result);
        setBottomSubmitted(true);
        setBottomSubmitting(false);
        // Redirect happens automatically in handleFormSubmission
      },
      (error) => {
        // Error callback
        console.error('Bottom form submission error:', error);
        setBottomApiError(error);
        setBottomSubmitting(false);
      }
    );
  };

  return (
    <>
      <SEO 
        title="Trademark Registration | Trademark Supremacy - Protect Your Brand Today"
        description="Professional trademark registration with licensed USPTO attorneys. Free consultation, 98% success rate, fast filing. Get expert brand protection in 24-48 hours."
        keywords="trademark registration, trademark filing, USPTO attorney, brand protection, trademark search, intellectual property"
        canonical="/lp/"
      />
      <div className="min-h-screen bg-white font-body">
        {/* Top Navigation Bar */}
      <nav className="bg-white border-b border-gray-200 py-4 px-4 sticky top-0 z-50 shadow-sm">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo - Left */}
          <div className="flex items-center">
            <img 
              src="/logo-black.png" 
              alt="Trademark Supremacy" 
              className="h-10 w-auto"
            />
          </div>
          
          {/* Right Side - Phone & Chat */}
          <div className="flex items-center gap-4">
            <a href="tel:+14158543407" className="flex items-center gap-2 text-gray-900 hover:text-[#FF6B35] transition-colors font-medium">
              <Phone className="w-5 h-5" />
              <span className="hidden sm:inline">+1 (415) 854 3407</span>
            </a>
            <button className="flex items-center gap-2 bg-[#FF6B35] hover:bg-[#FF8C42] text-white px-4 py-2 rounded-lg transition-all font-medium">
              <Mail className="w-4 h-4" />
              <span className="hidden sm:inline">Chat Now</span>
            </button>
          </div>
        </div>
      </nav>

      {/* Hero Section with Form */}
      <section className="relative bg-gradient-to-br from-gray-900 via-[#1a1a1a] to-black text-white py-20 px-4 overflow-hidden">
        {/* Animated Background Elements */}
        <div className="absolute inset-0 bg-gradient-to-tr from-[#FF6B35]/20 via-transparent to-[#FF8C42]/20 animate-pulse"></div>
        <div className="absolute inset-0 bg-gradient-to-bl from-transparent via-[#FF6B35]/10 to-transparent"></div>
        
        {/* Floating Elements */}
        <div className="absolute top-20 left-10 w-20 h-20 bg-[#FF6B35]/10 rounded-full blur-xl animate-bounce" style={{ animationDuration: '3s' }}></div>
        <div className="absolute top-40 right-20 w-32 h-32 bg-[#FF8C42]/10 rounded-full blur-2xl animate-bounce" style={{ animationDuration: '4s', animationDelay: '1s' }}></div>
        <div className="absolute bottom-40 left-1/4 w-24 h-24 bg-[#FF6B35]/10 rounded-full blur-xl animate-bounce" style={{ animationDuration: '5s', animationDelay: '2s' }}></div>

        {/* Floating Icons */}
        <div className="absolute top-32 right-1/4 animate-float" style={{ animationDelay: '0s' }}>
          <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center">
            <Shield className="w-6 h-6 text-[#FF6B35]" />
          </div>
        </div>
        <div className="absolute top-1/2 left-20 animate-float" style={{ animationDelay: '1s' }}>
          <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center">
            <Award className="w-6 h-6 text-[#FF6B35]" />
          </div>
        </div>
        <div className="absolute bottom-32 right-32 animate-float" style={{ animationDelay: '2s' }}>
          <div className="w-12 h-12 bg-white/10 backdrop-blur-sm rounded-xl flex items-center justify-center">
            <CheckCircle className="w-6 h-6 text-[#FF6B35]" />
          </div>
        </div>

        {/* Grid Pattern */}
        <div className="absolute inset-0 opacity-10" style={{
          backgroundImage: `linear-gradient(#FF6B35 1px, transparent 1px), linear-gradient(90deg, #FF6B35 1px, transparent 1px)`,
          backgroundSize: '50px 50px'
        }}></div>
        
        <div className="max-w-7xl mx-auto relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
            {/* Left: Content - 3 columns */}
            <div className="lg:col-span-3">
              {/* Trust Badges */}
              <div className="flex flex-wrap gap-4 mb-8">
                <div className="flex items-center gap-2 text-sm bg-white/10 backdrop-blur-sm px-3 py-2 rounded-full">
                  <CheckCircle className="w-4 h-4 text-[#FF6B35]" />
                  <span>USPTO Licensed</span>
                </div>
                <div className="flex items-center gap-2 text-sm bg-white/10 backdrop-blur-sm px-3 py-2 rounded-full">
                  <CheckCircle className="w-4 h-4 text-[#FF6B35]" />
                  <span>Fast Filing</span>
                </div>
                <div className="flex items-center gap-2 text-sm bg-white/10 backdrop-blur-sm px-3 py-2 rounded-full">
                  <CheckCircle className="w-4 h-4 text-[#FF6B35]" />
                  <span>Flat-Fee Pricing</span>
                </div>
              </div>

              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-heading mb-6 leading-tight">
                Protect Your Brand with
                <br />
                <span className="text-[#FF6B35]">a Registered Trademark</span>
              </h1>

              <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                Trademark Supremacy specializes in securing comprehensive legal protection for your brand name, logo, and intellectual property under U.S. Trademark Law. Our experienced attorneys guide you through every step of the USPTO registration process, ensuring your brand is fully protected against infringement. With our proven track record and streamlined approach, we make trademark registration simple, affordable, and stress-free for businesses of all sizes.
              </p>

              <div className="flex items-center gap-6">
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#FF6B35]">98%</div>
                  <div className="text-sm text-gray-400">Success Rate</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#FF6B35]">24-48h</div>
                  <div className="text-sm text-gray-400">Fast Filing</div>
                </div>
                <div className="text-center">
                  <div className="text-3xl font-bold text-[#FF6B35]">10K+</div>
                  <div className="text-sm text-gray-400">Clients</div>
                </div>
              </div>
            </div>

            {/* Right: Form - 2 columns */}
            <div className="lg:col-span-2 bg-white/10 backdrop-blur-md rounded-2xl p-8 border border-white/20">
              <div className="text-center mb-6">
                <div className="inline-flex items-center gap-2 bg-[#FF6B35]/20 text-[#FF6B35] px-4 py-2 rounded-full text-sm font-semibold mb-4">
                  <Sparkles className="w-4 h-4 animate-pulse" />
                  <span>Limited Spots Available</span>
                </div>
                <h3 className="text-2xl font-bold font-heading mb-2">Get Your FREE Brand Protection Consultation</h3>
                <p className="text-gray-300">Join 10,000+ businesses protecting their brands. Expert review in 24 hours—guaranteed.</p>
              </div>

              {/* API Error Display */}
              {heroApiError && !heroSubmitted && (
                <div className="bg-red-500/10 border border-red-500 text-red-300 px-4 py-3 rounded-lg mb-4">
                  <p className="text-sm">{heroApiError}</p>
                </div>
              )}

              {heroSubmitted ? (
                <div className="bg-green-500/10 border-2 border-green-500 rounded-xl p-6 text-center">
                  <CheckCircle className="w-12 h-12 text-green-500 mx-auto mb-3" />
                  <h4 className="text-lg font-bold mb-2">Thank You!</h4>
                  <p className="text-gray-300">We'll contact you within 24 hours to begin your registration.</p>
                </div>
              ) : (
                <form onSubmit={handleHeroSubmit} className="space-y-4">
                  <div>
                    <input
                      type="text"
                      name="name"
                      value={heroFormData.name}
                      onChange={handleHeroChange}
                      className={`w-full px-4 py-3 rounded-lg bg-white/10 border ${heroErrors.name ? 'border-red-500' : 'border-white/20'} text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]`}
                      placeholder="Your Name *"
                    />
                    {heroErrors.name && <p className="text-red-400 text-xs mt-1">{heroErrors.name}</p>}
                  </div>

                  <div>
                    <div className="flex gap-2">
                      <select
                        name="countryCode"
                        value={heroFormData.countryCode}
                        onChange={handleHeroChange}
                        className="w-24 px-2 py-3 rounded-lg bg-white/10 border border-white/20 text-white text-sm focus:outline-none focus:ring-2 focus:ring-[#FF6B35]"
                      >
                        {countryCodes.map((country, idx) => (
                          <option key={idx} value={country.code} className="bg-gray-900">
                            {country.flag} {country.code}
                          </option>
                        ))}
                      </select>
                      <input
                        type="tel"
                        name="phone"
                        value={heroFormData.phone}
                        onChange={handleHeroChange}
                        className={`flex-1 px-4 py-3 rounded-lg bg-white/10 border ${heroErrors.phone ? 'border-red-500' : 'border-white/20'} text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]`}
                        placeholder="Phone Number *"
                      />
                    </div>
                    {heroErrors.phone && <p className="text-red-400 text-xs mt-1">{heroErrors.phone}</p>}
                  </div>

                  <div>
                    <input
                      type="email"
                      name="email"
                      value={heroFormData.email}
                      onChange={handleHeroChange}
                      className={`w-full px-4 py-3 rounded-lg bg-white/10 border ${heroErrors.email ? 'border-red-500' : 'border-white/20'} text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]`}
                      placeholder="Your Email *"
                    />
                    {heroErrors.email && <p className="text-red-400 text-xs mt-1">{heroErrors.email}</p>}
                  </div>

                  <div>
                    <textarea
                      name="message"
                      value={heroFormData.message}
                      onChange={handleHeroChange}
                      rows="3"
                      className={`w-full px-4 py-3 rounded-lg bg-white/10 border ${heroErrors.message ? 'border-red-500' : 'border-white/20'} text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF6B35] resize-none`}
                      placeholder="Tell us about your brand *"
                    />
                    {heroErrors.message && <p className="text-red-400 text-xs mt-1">{heroErrors.message}</p>}
                  </div>

                  <button
                    type="submit"
                    disabled={heroSubmitting}
                    className="w-full bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] hover:from-[#FF8C42] hover:to-[#FF6B35] text-white font-bold px-6 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                  >
                    {heroSubmitting ? 'Submitting...' : 'Start Registration'} <Send className="w-4 h-4" />
                  </button>

                  <p className="text-center text-gray-400 text-xs">
                    No credit card required • Free consultation
                  </p>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Why Register a Trademark */}
      <section className="py-20 px-4 bg-gray-50" aria-labelledby="why-register-heading">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 id="why-register-heading" className="text-4xl md:text-5xl font-bold font-heading text-gray-900 mb-4">
              Why Your Business Needs a Registered Trademark
            </h2>
            <p className="text-xl text-gray-600">
              Protect your brand and establish legal ownership
            </p>
          </div>

          {/* Desktop Grid */}
          <div className="hidden md:grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              { icon: Shield, title: 'Prevent Brand Theft', description: 'Stop others from using your brand name or logo without permission' },
              { icon: Award, title: 'Build Credibility', description: 'Establish legal ownership and increase brand trust with customers' },
              { icon: Search, title: 'E-Commerce Protection', description: 'Protect your brand on Amazon, Shopify, and online platforms' },
              { icon: CheckCircle, title: 'Nationwide Rights', description: 'Gain exclusive federal rights across all 50 states' },
              { icon: DollarSign, title: 'Increase Business Value', description: 'Boost your company valuation and attract investors' },
              { icon: FileCheck, title: 'Legal Foundation', description: 'Create a strong legal foundation for brand enforcement' }
            ].map((benefit, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 group">
                <div className="w-14 h-14 bg-[#FF6B35]/10 rounded-lg flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all">
                  <benefit.icon className="w-7 h-7 text-[#FF6B35]" />
                </div>
                <h3 className="text-xl font-bold font-heading text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>

          {/* Mobile Horizontal Scroll */}
          <div className="md:hidden overflow-x-auto pb-4 -mx-4 px-4">
            <div className="flex gap-6" style={{ width: 'max-content' }}>
              {[
                { icon: Shield, title: 'Prevent Brand Theft', description: 'Stop others from using your brand name or logo without permission' },
                { icon: Award, title: 'Build Credibility', description: 'Establish legal ownership and increase brand trust with customers' },
                { icon: Search, title: 'E-Commerce Protection', description: 'Protect your brand on Amazon, Shopify, and online platforms' },
                { icon: CheckCircle, title: 'Nationwide Rights', description: 'Gain exclusive federal rights across all 50 states' },
                { icon: DollarSign, title: 'Increase Business Value', description: 'Boost your company valuation and attract investors' },
                { icon: FileCheck, title: 'Legal Foundation', description: 'Create a strong legal foundation for brand enforcement' }
              ].map((benefit, index) => (
                <div key={index} className="bg-white rounded-xl p-6 shadow-lg flex-shrink-0" style={{ width: '280px' }}>
                  <div className="w-14 h-14 bg-[#FF6B35]/10 rounded-lg flex items-center justify-center mb-4">
                    <benefit.icon className="w-7 h-7 text-[#FF6B35]" />
                  </div>
                  <h3 className="text-xl font-bold font-heading text-gray-900 mb-3">{benefit.title}</h3>
                  <p className="text-gray-600">{benefit.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* What is Trademark Section */}
      <section className="py-20 px-4 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Content */}
            <div>
              <div className="inline-block bg-[#FF6B35]/10 text-[#FF6B35] px-4 py-2 rounded-full text-sm font-semibold mb-6">
                Understanding Trademarks
              </div>
              <h2 className="text-4xl md:text-5xl font-bold font-heading text-black mb-6">
                What is a Trademark?
              </h2>
              <div className="space-y-4 text-lg text-gray-700 leading-relaxed">
                <p>
                  A trademark is a distinctive sign, symbol, word, phrase, logo, or design that identifies and distinguishes the source of goods or services of one party from those of others. It's essentially your brand's fingerprint in the marketplace.
                </p>
                <p>
                  Think of iconic brands like Nike's swoosh, Apple's apple, or McDonald's golden arches. These trademarks are instantly recognizable and legally protected, preventing others from using confusingly similar marks.
                </p>
                <p>
                  In the United States, trademark rights are established through either actual use in commerce or by filing an application with the United States Patent and Trademark Office (USPTO). Once registered, a trademark can last indefinitely as long as it continues to be used and properly maintained.
                </p>
                <p className="font-semibold text-black">
                  Registering your trademark provides nationwide protection, legal presumption of ownership, and the exclusive right to use your mark in connection with your goods or services.
                </p>
              </div>
            </div>

            {/* Right: CTA Box */}
            <div className="bg-gradient-to-br from-[#1a2332] to-[#0f1419] rounded-2xl p-8 shadow-2xl flex flex-col justify-between h-full">
              <div>
                <div className="text-center mb-8">
                  <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
                    Protect Your Brand Today
                  </h3>
                  <p className="text-gray-300 text-lg">
                    Don't wait until it's too late. Get your trademark registered with expert attorneys.
                  </p>
                </div>

                {/* Benefits */}
                <div className="space-y-4 mb-8">
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-white text-sm">✓</span>
                    </div>
                    <span className="text-gray-200">Free comprehensive trademark search</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-white text-sm">✓</span>
                    </div>
                    <span className="text-gray-200">Licensed U.S. trademark attorneys</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-white text-sm">✓</span>
                    </div>
                    <span className="text-gray-200">24-48 hour response time guaranteed</span>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-6 h-6 bg-[#FF6B35] rounded-full flex items-center justify-center flex-shrink-0 mt-1">
                      <span className="text-white text-sm">✓</span>
                    </div>
                    <span className="text-gray-200">No hidden fees - transparent pricing</span>
                  </div>
                </div>
              </div>

              {/* CTA Buttons */}
              <div className="space-y-3">
                <button
                  onClick={() => {
                    const heroForm = document.querySelector('#hero-form');
                    if (heroForm) heroForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  }}
                  className="w-full bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] hover:from-[#FF8C42] hover:to-[#FF6B35] text-white font-bold px-8 py-4 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center justify-center gap-2"
                >
                  <Shield className="w-5 h-5" />
                  Start Registration Now
                </button>
                <div className="text-center text-sm text-gray-400">
                  <Clock className="w-4 h-4 inline mr-1" />
                  Most applications filed within 24 hours
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section - Using Component */}
      <div className="bg-white">
        <ProcessSection />
      </div>

      {/* Pricing Section - Using Component */}
      <div className="bg-gray-50">
        <PricingSection />
      </div>

      {/* Why Choose Us */}
      <section className="py-20 px-4 bg-white" aria-labelledby="why-choose-heading">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 id="why-choose-heading" className="text-4xl md:text-5xl font-bold font-heading text-gray-900 mb-4">
              Why Thousands of Businesses Trust Trademark Supremacy
            </h2>
            <div className="flex items-center justify-center gap-1 mb-4">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star key={star} className="w-6 h-6 fill-[#FF6B35] text-[#FF6B35]" />
              ))}
              <span className="ml-2 text-gray-600">Rated by 500+ entrepreneurs nationwide</span>
            </div>
          </div>

          {/* Desktop Grid */}
          <div className="hidden md:grid grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: Shield, title: 'Experienced IP Attorneys', description: 'Decades of combined expertise in U.S. trademark law' },
              { icon: Clock, title: 'Fast Filing Process', description: 'Quick turnaround and real-time status tracking' },
              { icon: DollarSign, title: 'Transparent Pricing', description: 'No hidden costs — clear and upfront fees' },
              { icon: Award, title: 'Full Legal Support', description: 'From search to registration to enforcement' }
            ].map((feature, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 shadow-lg text-center hover:shadow-xl transition-all">
                <div className="w-16 h-16 bg-[#FF6B35] rounded-full flex items-center justify-center mx-auto mb-4">
                  <feature.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-xl font-bold font-heading text-gray-900 mb-3">{feature.title}</h3>
                <p className="text-gray-600">{feature.description}</p>
              </div>
            ))}
          </div>

          {/* Mobile Horizontal Scroll */}
          <div className="md:hidden overflow-x-auto pb-4 -mx-4 px-4">
            <div className="flex gap-6" style={{ width: 'max-content' }}>
              {[
                { icon: Shield, title: 'Experienced IP Attorneys', description: 'Decades of combined expertise in U.S. trademark law' },
                { icon: Clock, title: 'Fast Filing Process', description: 'Quick turnaround and real-time status tracking' },
                { icon: DollarSign, title: 'Transparent Pricing', description: 'No hidden costs — clear and upfront fees' },
                { icon: Award, title: 'Full Legal Support', description: 'From search to registration to enforcement' }
              ].map((feature, index) => (
                <div key={index} className="bg-gray-50 rounded-xl p-6 shadow-lg text-center flex-shrink-0" style={{ width: '280px' }}>
                  <div className="w-16 h-16 bg-[#FF6B35] rounded-full flex items-center justify-center mx-auto mb-4">
                    <feature.icon className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold font-heading text-gray-900 mb-3">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 px-4 bg-gray-50" aria-labelledby="testimonials-heading">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 id="testimonials-heading" className="text-4xl md:text-5xl font-bold font-heading text-gray-900 mb-4">
              What Our Clients Say
            </h2>
          </div>

          {/* Desktop Grid */}
          <div className="hidden md:grid grid-cols-3 gap-8">
            {[
              { quote: "Trademark Supremacy made the whole process seamless! I got my approval in weeks.", author: "Amanda R.", role: "eCommerce Seller" },
              { quote: "Professional, transparent, and incredibly helpful. Highly recommend for any business owner.", author: "Michael T.", role: "Tech Startup Founder" },
              { quote: "The attorneys were knowledgeable and guided me through every step. Worth every penny!", author: "Sarah L.", role: "Small Business Owner" }
            ].map((testimonial, index) => (
              <div key={index} className="bg-white rounded-xl p-8 shadow-lg border-l-4 border-[#FF6B35]">
                <div className="flex gap-1 mb-4">
                  {[1, 2, 3, 4, 5].map((star) => (
                    <Star key={star} className="w-5 h-5 fill-[#FF6B35] text-[#FF6B35]" />
                  ))}
                </div>
                <p className="text-gray-700 italic mb-4">"{testimonial.quote}"</p>
                <div>
                  <p className="font-bold text-gray-900">{testimonial.author}</p>
                  <p className="text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            ))}
          </div>

          {/* Mobile Horizontal Scroll */}
          <div className="md:hidden overflow-x-auto pb-4 -mx-4 px-4">
            <div className="flex gap-6" style={{ width: 'max-content' }}>
              {[
                { quote: "Trademark Supremacy made the whole process seamless! I got my approval in weeks.", author: "Amanda R.", role: "eCommerce Seller" },
                { quote: "Professional, transparent, and incredibly helpful. Highly recommend for any business owner.", author: "Michael T.", role: "Tech Startup Founder" },
                { quote: "The attorneys were knowledgeable and guided me through every step. Worth every penny!", author: "Sarah L.", role: "Small Business Owner" }
              ].map((testimonial, index) => (
                <div key={index} className="bg-white rounded-xl p-8 shadow-lg border-l-4 border-[#FF6B35] flex-shrink-0" style={{ width: '300px' }}>
                  <div className="flex gap-1 mb-4">
                    {[1, 2, 3, 4, 5].map((star) => (
                      <Star key={star} className="w-5 h-5 fill-[#FF6B35] text-[#FF6B35]" />
                    ))}
                  </div>
                  <p className="text-gray-700 italic mb-4">"{testimonial.quote}"</p>
                  <div>
                    <p className="font-bold text-gray-900">{testimonial.author}</p>
                    <p className="text-sm text-gray-600">{testimonial.role}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA Form - Same style as home page */}
      <section className="py-20 bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-4xl md:text-5xl font-bold font-heading mb-4">
              Ready to Protect Your Brand?
            </h2>
            <p className="text-lg text-gray-300 max-w-2xl mx-auto">
              Fill out the form below and our trademark experts will get back to you within 24 hours
            </p>
          </div>

          {/* API Error Display */}
          {bottomApiError && !bottomSubmitted && (
            <div className="bg-red-500/10 border border-red-500 text-red-300 px-4 py-3 rounded-lg mb-4 text-center max-w-2xl mx-auto">
              <p className="text-sm">{bottomApiError}</p>
            </div>
          )}

          {bottomSubmitted && (
            <div className="bg-[#FF6B35] text-white px-6 py-3 rounded-lg mb-6 text-center max-w-2xl mx-auto">
              ✓ Thank you! We'll contact you within 24 hours.
            </div>
          )}

          <form onSubmit={handleBottomSubmit} className="w-full">
            <div className="flex flex-col lg:flex-row gap-3 mb-3 items-start">
              <div className="flex-1">
                <input
                  type="text"
                  name="name"
                  value={bottomFormData.name}
                  onChange={handleBottomChange}
                  className={`w-full h-12 px-4 py-3 bg-white/10 border ${bottomErrors.name ? 'border-red-500' : 'border-white/20'} rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]`}
                  placeholder="Your Name *"
                />
                {bottomErrors.name && <p className="text-red-400 text-xs mt-1">{bottomErrors.name}</p>}
              </div>

              <div className="flex-1">
                <div className="flex">
                  <select
                    name="countryCode"
                    value={bottomFormData.countryCode}
                    onChange={handleBottomChange}
                    className="w-24 h-12 px-2 py-3 bg-white/10 border border-white/20 rounded-l-lg rounded-r-none border-r-0 text-white text-sm focus:outline-none focus:ring-2 focus:ring-[#FF6B35]"
                  >
                    {countryCodes.map((country, idx) => (
                      <option key={idx} value={country.code} className="bg-gray-900">
                        {country.flag} {country.code}
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    name="phone"
                    value={bottomFormData.phone}
                    onChange={handleBottomChange}
                    className={`flex-1 h-12 px-4 py-3 bg-white/10 border ${bottomErrors.phone ? 'border-red-500' : 'border-white/20'} rounded-r-lg rounded-l-none text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]`}
                    placeholder="Phone Number *"
                  />
                </div>
                {bottomErrors.phone && <p className="text-red-400 text-xs mt-1">{bottomErrors.phone}</p>}
              </div>

              <div className="flex-1">
                <input
                  type="email"
                  name="email"
                  value={bottomFormData.email}
                  onChange={handleBottomChange}
                  className={`w-full h-12 px-4 py-3 bg-white/10 border ${bottomErrors.email ? 'border-red-500' : 'border-white/20'} rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]`}
                  placeholder="Your Email *"
                />
                {bottomErrors.email && <p className="text-red-400 text-xs mt-1">{bottomErrors.email}</p>}
              </div>

              <div className="flex-1">
                <input
                  type="text"
                  name="message"
                  value={bottomFormData.message}
                  onChange={handleBottomChange}
                  className={`w-full h-12 px-4 py-3 bg-white/10 border ${bottomErrors.message ? 'border-red-500' : 'border-white/20'} rounded-lg text-white placeholder-gray-300 focus:outline-none focus:ring-2 focus:ring-[#FF6B35]`}
                  placeholder="Your Message *"
                />
                {bottomErrors.message && <p className="text-red-400 text-xs mt-1">{bottomErrors.message}</p>}
              </div>

              <div>
                <button
                  type="submit"
                  disabled={bottomSubmitting}
                  className="w-full lg:w-auto h-12 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] hover:from-[#FF8C42] hover:to-[#FF6B35] text-white font-bold px-8 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg shadow-[#FF6B35]/30 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
                >
                  {bottomSubmitting ? 'Submitting...' : 'Start Registration'} <Send className="w-4 h-4 ml-2 inline" />
                </button>
              </div>
            </div>

            <p className="text-sm text-gray-400 text-center mt-4">
              No credit card required • Free consultation • Money-back guarantee
            </p>
          </form>
        </div>
      </section>

      {/* Footer - Flattened */}
      <footer className="bg-gray-900 text-white py-8 px-4">
        <div className="max-w-7xl mx-auto">
          {/* Main Footer Content */}
          <div className="flex flex-col md:flex-row items-center justify-between gap-6 pb-6 mb-6 border-b border-gray-800">
            {/* Left: Logo & Disclaimer */}
            <div className="flex items-center gap-4 text-center md:text-left">
              <img 
                src="/logo-white.png" 
                alt="Trademark Supremacy" 
                className="h-12 w-auto flex-shrink-0"
              />
              <div>
                <p className="text-sm text-gray-400 max-w-md">
                  Legal services in trademark and IP law. All filings handled by licensed U.S. attorneys.
                </p>
              </div>
            </div>

            {/* Right: Contact Info */}
            <div className="flex flex-col sm:flex-row items-center gap-6">
              <a href="mailto:info@trademarksupremacy.com" className="flex items-center gap-2 text-gray-300 hover:text-[#FF6B35] transition-colors">
                <Mail className="w-4 h-4" />
                <span className="text-sm">info@trademarksupremacy.com</span>
              </a>
              <a href="tel:+14158543407" className="flex items-center gap-2 text-gray-300 hover:text-[#FF6B35] transition-colors">
                <Phone className="w-4 h-4" />
                <span className="text-sm">+1 (415) 854 3407</span>
              </a>
              <div className="flex items-center gap-2 text-gray-300">
                <MapPin className="w-4 h-4" />
                <span className="text-sm">New York, NY</span>
              </div>
            </div>
          </div>

          {/* Bottom Row: Copyright, Links & Trust Badges */}
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <p className="text-sm text-gray-500">
                &copy; 2024 Trademark Supremacy. All rights reserved.
              </p>
              <div className="flex items-center gap-4 text-sm">
                <a href="/privacy-policy" className="text-gray-400 hover:text-[#FF6B35] transition-colors">
                  Privacy Policy
                </a>
                <span className="text-gray-600">|</span>
                <a href="/terms-conditions" className="text-gray-400 hover:text-[#FF6B35] transition-colors">
                  Terms & Conditions
                </a>
              </div>
            </div>
            
            <div className="flex items-center gap-6">
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <Shield className="w-4 h-4 text-[#FF6B35]" />
                <span>Secure Site</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <CheckCircle className="w-4 h-4 text-[#FF6B35]" />
                <span>Licensed Attorneys</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
    </>
  );
};

export default TrademarkPPCLanding;
